import React from 'react';
import Helmet from 'react-helmet';

type PageBackgrondProps = {backgroundColor: string, textColor: string}
export function PageBackground(props: PageBackgrondProps) {
  return <Helmet>
      <style>{`body { transition: background-color .2s; background-color: ${props.backgroundColor}; color: ${props.textColor};}`}</style>
    </Helmet>
}